<template>
    <div>

        <rkm-row>

            <rkm-col
                class="mb-2"
                cols="12"
            >

                <rkm-button
                    @click="selecionarTodos()"
                    color="primary"
                >
                    <template v-if="!exames.find(item => item.selecionado)">
                        Selecionar todos
                    </template>

                    <template v-else>
                        Desmarcar selecionado(s)
                    </template>
                </rkm-button>
            </rkm-col>

            <rkm-col
                class="mb-2"
                cols="12"
            >
                <rkm-table
                    :items="exames"
                    :fields="fields"
                    hide-filters
                    sort-by="data"
                    :sort-compare="sortCompare"
                    hide-pagination
                >

                <template v-slot:cell(checkbox)="{ item }">
                    <rkm-form-checkbox
                        v-model="item.selecionado"
                        @change="handleExames()"
                    />
                </template>

                    <template v-slot:cell(actions)="{ item }">

                        <rkm-button
                            color="danger"
                            small
                            title="Descartar exame"
                            @click.stop="descartarAmbulatorioAtendimento(item)"
                        >
                            <rkm-icon icon="trash" />
                        </rkm-button>

                        <rkm-button
                            color="primary"
                            small
                            title="Agendar exame"
                            @click.stop="agendarAmbulatorioAtendimento(item)"
                        >
                            <rkm-icon icon="clone" />
                        </rkm-button>
                    </template>
                </rkm-table>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, error, object, formats, data, stringCase } from '@/mixins'

// Moment.
import moment from 'moment'

export default {
    computed: {
        fields() {
            const fields = [
                {
                    key: 'checkbox',
                    label: '#',
                    class: 'col-min text-center',
                },
                {
                    key: "exameNome",
                    label: "Exame",
                    sortable: true
                },
                {
                    key: "grupoNome",
                    label: "Grupo",
                    sortable: true
                },
                {
                    key: "data",
                    label: "Data da solicitação",
                    sortable: true
                },
                {
                    key: "profissionalNome",
                    label: "Profissional solicitante",
                    sortable: true
                },
                {
                    key: "unidade",
                    label: "Unidade",
                    sortable: true
                },
                {
                    key: "infraestrutura",
                    label: "Local de atendimento",
                    sortable: true
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min text-center'
                }
            ]

            return fields
        },
    },
    created() {
        this.repositories = {
            agendamento: this.getConectaSusRepository('exameImagem.agendamento')
        }
    },
    data() {
        return {
            modalPacienteId: null,
            reagendar: null,
        }
    },
    mixins: [repository, error, object, formats, data, stringCase],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        sortCompare(a, b, key) {

            if (key === 'data') {

                const dateA = moment(a[key], 'DD/MM/YYYY HH:mm')
                const dateB = moment(b[key], 'DD/MM/YYYY HH:mm')

                if (dateA > dateB) return 1
                else if (dateA < dateB) return -1
                else return 0

            } else {

                return false
            }
        },
        selecionarTodos(){

            if(this.exames.find(item => item.selecionado)){

                this.exames.map(item => (item.selecionado = false))
                this.$emit('handleSelecionado', false)
            } else {

                this.exames.map(item => (item.selecionado = true))
                this.$emit('handleSelecionado', true)
            }
        },
        handleExames() {

            if(this.exames.find(item => item.selecionado)){

                this.$emit('handleSelecionado', true)
            } else {

                this.$emit('handleSelecionado', false)
            }
        },
        agendarAmbulatorioAtendimento(item) {

            this.$emit('agendarAmbulatorioAtendimento', item)
        },
        descartarAmbulatorioAtendimento(item) {

            this.$emit('descartarAmbulatorioAtendimento', item)
        }
    },
    props: {
        exames: { type: Array, required: true},
    },
}
</script>

<style scoped>
.rkm-list-group-item {
    padding: 0.75rem 1.25rem;
}
.rkm-list-group-item:focus {
    outline: none;
}
.rkm-list-group-item:first-child {
    border-radius: 0;
}
.rkm-list-group-item:last-child {
    border-radius: 0;
}
.rkm-list-group-item > .row {
    margin: 0;
}
.rkm-collapse {
    border-bottom: 1px solid rgba(0, 0, 0, .15);
    border-left: 1px solid rgba(0, 0, 0, .15);
    border-right: 1px solid rgba(0, 0, 0, .15);
}
.font-13 {
    font-size: 13px!important;
}
h4 {
    font-size: 20px!important;
    font-weight: 600!important;
}
</style>